module.exports = __webpack_public_path__ + "static/media/icon_has_bridge.d168068f.svg";